module.exports = __webpack_public_path__ + "static/media/ShareUniversal.4da49944.png";